module.exports = __webpack_public_path__ + "wide-arrow.png?43003a491ebb4f918c4de3c13a3bb321";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wide-arrow.png
// module id = 70
// module chunks = 0